module.exports = __webpack_public_path__ + "img/title.8b0c7143.png";